import React from "react";
import styles from "./CalendarDay.module.scss";

import tickIcon from "../../assets/icons/icon-yes 1.png";
import TreasureChestBadge from "../../assets/imgs/treasure_chest_badge.png";
import TreasureChestBadgeBrown from "../../assets/imgs/treasure_chest_badge_brown.png";
import BoxPrize from "../../assets/imgs/box-prize.png";
import BoxPrizeBrown from "../../assets/imgs/box-prize-brown.png";
import { ReactComponent as TowerLogoBrownIcon } from "../../assets/icons/logo-tower-no-bg.svg";
import { useTranslation } from "react-i18next";

const CalendarDay = ({
    day,
    currentIteration,
    endOfMonthDate,
    remainingDays,
    claimed,
    daysBonus,
    nextDaysBonus,
    handleClaim,
    countdownTime,
    sevenDayBonus,
    handleCatchUp,
    catchUpAmount,
}) => {
    const [t] = useTranslation();
    const renderTokenAmount =
        day > 28 ? (
            ""
        ) : day % 7 === 0 ? (
            <div className={styles.reward_token_amount_seven}>
                {sevenDayBonus[day].value}
                <TowerLogoBrownIcon
                    fill="#957F66"
                    className={styles.tower_img}
                />
                <span className={styles.plus_sign}>+</span>
                {day === currentIteration && !claimed ? (
                    <img
                        src={sevenDayBonus[day].image}
                        className={styles.map_img}
                        alt="maps-icon"
                        style={{ width: "24px" }}
                    />
                ) : (
                    <img
                        src={sevenDayBonus[day].imageT}
                        className={styles.map_img}
                        alt="maps-icon"
                        style={{ width: "24px" }}
                    />
                )}
                {day === 28 && endOfMonthDate === 28 && (
                    <>
                        <span className={styles.plus_sign}>+</span>
                        <img
                            src={TreasureChestBadgeBrown}
                            className={styles.badge_img}
                            alt="treasure-chest-badge"
                            style={{ width: "20px" }}
                        />
                    </>
                )}
            </div>
        ) : day === currentIteration && !claimed ? (
            <h5 className={styles.reward_token_amount}>+{daysBonus?.value}</h5>
        ) : claimed && day === currentIteration + 1 ? (
            <h5 className={styles.reward_token_amount_next_day}>
                +{nextDaysBonus?.value}
            </h5>
        ) : null;

    const renderOnlySeventhDayTokenAmount = day % 7 === 0 && (
        <div className={styles.reward_token_amount_seven}>
            {sevenDayBonus[day].value}
            <TowerLogoBrownIcon fill="#957F66" className={styles.tower_img} />
            <span className={styles.plus_sign}>+</span>
            {day === currentIteration && !claimed ? (
                <img
                    src={sevenDayBonus[day].image}
                    className={styles.map_img}
                    alt="maps-icon"
                    style={{ width: "24px" }}
                />
            ) : (
                <img
                    src={sevenDayBonus[day].imageT}
                    className={styles.map_img}
                    alt="maps-icon"
                    style={{ width: "24px" }}
                />
            )}
            {day === 28 && endOfMonthDate === 28 && (
                <>
                    <span className={styles.plus_sign}>+</span>
                    <img
                        src={TreasureChestBadgeBrown}
                        className={styles.badge_img}
                        alt="treasure-chest-badge"
                        style={{ width: "20px" }}
                    />
                </>
            )}
        </div>
    );

    const handleClick = () => {
        if (!claimed) {
            handleClaim();
        }
    };

    return (
        <>
            {!claimed ? (
                day <= remainingDays + currentIteration ? (
                    day < currentIteration ? (
                        <div className={styles.day_container}>
                            <div
                                className={`${styles.calendar_day} ${
                                    day > 28
                                        ? styles.claimed_extra
                                        : styles.claimed
                                }`}
                            >
                                <div className={styles.day_number}>{day}</div>
                                {renderTokenAmount}
                                <img
                                    className={styles.tickIcon}
                                    src={tickIcon}
                                    alt=""
                                />
                            </div>
                        </div>
                    ) : day === currentIteration ? (
                        <div
                            className={`${styles.day_container} ${
                                day === endOfMonthDate &&
                                day % 7 !== 0 &&
                                styles.grid_double_span
                            }`}
                            onClick={handleClick}
                        >
                            {day > 28 ? (
                                day === endOfMonthDate ? (
                                    <div
                                        className={`${styles.calendar_day} ${
                                            claimed
                                                ? styles.claimed_extra_final
                                                : styles.not_claimed_extra_final
                                        }`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                        <div
                                            className={`${styles.contents} d-flex align-items-center justify-content-center`}
                                        >
                                            <span className={styles.text}>
                                                Attendance
                                            </span>
                                            <img
                                                src={
                                                    claimed
                                                        ? TreasureChestBadgeBrown
                                                        : TreasureChestBadge
                                                }
                                                className={styles.badge_img}
                                                alt="treasure-chest-badge"
                                            />
                                            <span className={styles.text}>
                                                +
                                            </span>
                                            <img
                                                src={
                                                    claimed
                                                        ? BoxPrizeBrown
                                                        : BoxPrize
                                                }
                                                className={styles.map_img}
                                                alt="box-prize"
                                                style={{ width: "20px" }}
                                            />
                                        </div>
                                        <span
                                            className={
                                                styles.current_days_remaining_time
                                            }
                                        >
                                            {countdownTime?.hours}h{" "}
                                            {countdownTime?.minutes}m{" "}
                                            {countdownTime?.seconds}s
                                        </span>
                                        <img
                                            className={`${
                                                claimed
                                                    ? styles.tickIcon
                                                    : "d-none"
                                            }`}
                                            src={tickIcon}
                                            alt=""
                                        />
                                    </div>
                                ) : (
                                    <div
                                        className={`${styles.calendar_day} ${
                                            claimed
                                                ? styles.claimed_extra
                                                : styles.not_claimed_extra
                                        }`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                        <span
                                            className={
                                                styles.current_days_remaining_time
                                            }
                                        >
                                            {countdownTime?.hours}h{" "}
                                            {countdownTime?.minutes}m{" "}
                                            {countdownTime?.seconds}s
                                        </span>
                                        <img
                                            className={`${
                                                claimed
                                                    ? styles.tickIcon
                                                    : "d-none"
                                            }`}
                                            src={tickIcon}
                                            alt=""
                                        />
                                    </div>
                                )
                            ) : (
                                <div
                                    className={`${styles.calendar_day} ${
                                        claimed
                                            ? styles.claimed
                                            : styles.not_claimed
                                    }`}
                                >
                                    <div className={styles.day_number}>
                                        {day}
                                    </div>
                                    {renderTokenAmount}
                                    <span
                                        className={
                                            styles.current_days_remaining_time
                                        }
                                    >
                                        {countdownTime?.hours}h{" "}
                                        {countdownTime?.minutes}m{" "}
                                        {countdownTime?.seconds}s
                                    </span>
                                    <img
                                        className={`${
                                            claimed ? styles.tickIcon : "d-none"
                                        }`}
                                        src={tickIcon}
                                        alt=""
                                    />
                                </div>
                            )}
                        </div>
                    ) : day === currentIteration + 1 && claimed ? (
                        <div
                            className={`${styles.day_container} ${
                                day === endOfMonthDate &&
                                day % 7 !== 0 &&
                                styles.grid_double_span
                            }`}
                            style={{
                                width:
                                    day === endOfMonthDate && day % 7 !== 0
                                        ? "150px"
                                        : "",
                            }}
                        >
                            {day > 28 ? (
                                day === endOfMonthDate ? (
                                    <div
                                        className={`${styles.calendar_day} ${styles.other_day_extra_final}`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                        <span className={styles.text}>
                                            Attendance
                                        </span>
                                        <img
                                            src={TreasureChestBadgeBrown}
                                            className={styles.badge_img}
                                            alt="treasure-chest-badge"
                                        />
                                        <span className={styles.text}>+</span>
                                        <img
                                            src={BoxPrizeBrown}
                                            className={styles.map_img}
                                            alt="box-prize"
                                            style={{
                                                width: "18px",
                                                marginLeft: "2px",
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        className={`${styles.calendar_day} ${styles.other_day_extra}`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div
                                    className={`${styles.calendar_day} ${styles.other_day} ${styles.candidate_day}`}
                                >
                                    <div className={styles.day_number}>
                                        {day}
                                    </div>
                                    {renderTokenAmount}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div
                            className={`${styles.day_container} ${
                                day === endOfMonthDate &&
                                day % 7 !== 0 &&
                                styles.grid_double_span
                            }`}
                            style={{
                                width:
                                    day === endOfMonthDate && day % 7 !== 0
                                        ? "150px"
                                        : "",
                            }}
                        >
                            {day > 28 ? (
                                day === endOfMonthDate ? (
                                    <div
                                        className={`${styles.calendar_day} ${styles.other_day_extra_final}`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                        <span className={styles.text}>
                                            Attendance
                                        </span>
                                        <img
                                            src={TreasureChestBadgeBrown}
                                            className={styles.badge_img}
                                            alt="treasure-chest-badge"
                                        />
                                        <span className={styles.text}>+</span>
                                        <img
                                            src={BoxPrizeBrown}
                                            className={styles.map_img}
                                            alt="box-prize"
                                            style={{
                                                width: "18px",
                                                marginLeft: "2px",
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        className={`${styles.calendar_day} ${styles.other_day_extra}`}
                                    >
                                        <div className={styles.day_number}>
                                            {day}
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div
                                    className={`${styles.calendar_day} ${styles.other_day}`}
                                >
                                    <div className={styles.day_number}>
                                        {day}
                                    </div>
                                    {renderTokenAmount}
                                </div>
                            )}
                        </div>
                    )
                ) : (
                    <>
                        {day > 28 ? (
                            day > endOfMonthDate ? (
                                <></>
                            ) : (
                                <div
                                    className={`${styles.day_container}  ${
                                        day === endOfMonthDate &&
                                        styles.grid_double_span
                                    }`}
                                >
                                    {day === endOfMonthDate ? (
                                        <div
                                            className={`${styles.calendar_day} ${styles.not_claimable_day_extra_final}`}
                                        >
                                            <div className={styles.day_number}>
                                                {day}
                                            </div>
                                            <span className={styles.text}>
                                                Attendance
                                            </span>
                                            <img
                                                src={TreasureChestBadgeBrown}
                                                className={styles.badge_img}
                                                alt="treasure-chest-badge"
                                                style={{ opacity: "0.2" }}
                                            />
                                            <span className={styles.text}>
                                                +
                                            </span>
                                            <img
                                                src={BoxPrizeBrown}
                                                className={styles.badge_img}
                                                alt="box-prize"
                                                style={{ opacity: "0.2" }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className={`${styles.calendar_day} ${styles.not_claimable_day_extra}`}
                                        >
                                            <div className={styles.day_number}>
                                                {day}
                                            </div>
                                            {renderTokenAmount}
                                        </div>
                                    )}
                                </div>
                            )
                        ) : (
                            <div className={styles.day_container}>
                                <div
                                    className={`${styles.calendar_day} ${styles.not_claimable_day}`}
                                >
                                    <div className={styles.day_number}>
                                        {day}
                                    </div>
                                    {renderTokenAmount}
                                </div>
                            </div>
                        )}
                    </>
                )
            ) : day <= currentIteration ? (
                <div
                    className={`${styles.day_container} ${
                        day === endOfMonthDate &&
                        day % 7 !== 0 &&
                        styles.grid_double_span
                    }`}
                    onClick={handleClick}
                >
                    {day > 28 ? (
                        day === endOfMonthDate ? (
                            <div
                                className={`${styles.calendar_day} ${
                                    claimed
                                        ? styles.claimed_extra_final
                                        : styles.not_claimed_extra_final
                                }`}
                            >
                                <div className={styles.day_number}>{day}</div>
                                <div
                                    className={`${styles.contents} d-flex align-items-center justify-content-center`}
                                >
                                    <span className={styles.text}>
                                        Attendance
                                    </span>
                                    <img
                                        src={
                                            claimed
                                                ? TreasureChestBadgeBrown
                                                : TreasureChestBadge
                                        }
                                        className={styles.badge_img}
                                        alt="treasure-chest-badge"
                                    />
                                    <span className={styles.text}>+</span>
                                    <img
                                        src={claimed ? BoxPrizeBrown : BoxPrize}
                                        className={styles.map_img}
                                        alt="box-prize"
                                        style={{ width: "20px" }}
                                    />
                                </div>
                                <span
                                    className={
                                        styles.current_days_remaining_time
                                    }
                                >
                                    {countdownTime?.hours}h{" "}
                                    {countdownTime?.minutes}m{" "}
                                    {countdownTime?.seconds}s
                                </span>
                                <img
                                    className={`${
                                        claimed ? styles.tickIcon : "d-none"
                                    }`}
                                    src={tickIcon}
                                    alt=""
                                />
                            </div>
                        ) : (
                            <div
                                className={`${styles.calendar_day} ${
                                    claimed
                                        ? styles.claimed_extra
                                        : styles.not_claimed_extra
                                }`}
                            >
                                <div className={styles.day_number}>{day}</div>
                                <span
                                    className={
                                        styles.current_days_remaining_time
                                    }
                                >
                                    {countdownTime?.hours}h{" "}
                                    {countdownTime?.minutes}m{" "}
                                    {countdownTime?.seconds}s
                                </span>
                                <img
                                    className={`${
                                        claimed ? styles.tickIcon : "d-none"
                                    }`}
                                    src={tickIcon}
                                    alt=""
                                />
                            </div>
                        )
                    ) : (
                        <div
                            className={`${styles.calendar_day} ${
                                claimed ? styles.claimed : styles.not_claimed
                            }`}
                        >
                            <div className={styles.day_number}>{day}</div>
                            {renderTokenAmount}
                            <span
                                className={styles.current_days_remaining_time}
                            >
                                {countdownTime?.hours}h {countdownTime?.minutes}
                                m {countdownTime?.seconds}s
                            </span>
                            <img
                                className={`${
                                    claimed ? styles.tickIcon : "d-none"
                                }`}
                                src={tickIcon}
                                alt=""
                            />
                        </div>
                    )}
                </div>
            ) : day <= endOfMonthDate - remainingDays ? (
                <div
                    className={`${styles.day_container} ${
                        day === endOfMonthDate &&
                        day % 7 !== 0 &&
                        styles.grid_double_span
                    }`}
                    style={{
                        width:
                            day === endOfMonthDate && day % 7 !== 0
                                ? "150px"
                                : "",
                    }}
                >
                    <div className={styles.catch_up_container}>
                        <div className={styles.catch_up_text}>
                            {t("Pay")}
                            <TowerLogoBrownIcon
                                fill="#69341D"
                                className={styles.tower_logo}
                            />
                            <span>{catchUpAmount}</span>
                            {t("to")}
                        </div>
                        {day === currentIteration + 1 ? (
                            <button
                                className={styles.catch_up_btn}
                                onClick={() => handleCatchUp(day)}
                            >
                                Catch Up
                            </button>
                        ) : (
                            <div
                                className={`${styles.catch_up_btn} ${styles.unavailable}`}
                            >
                                Catch Up
                            </div>
                        )}
                    </div>

                    {day > 28 ? (
                        day === endOfMonthDate ? (
                            <div
                                className={`${styles.calendar_day} ${styles.other_day_extra_final}`}
                            >
                                <div className={styles.day_number}>{day}</div>
                                <span className={styles.text}>Attendance</span>
                                <img
                                    src={TreasureChestBadgeBrown}
                                    className={styles.badge_img}
                                    alt="treasure-chest-badge"
                                />
                                <span className={styles.text}>+</span>
                                <img
                                    src={BoxPrizeBrown}
                                    className={styles.map_img}
                                    alt="box-prize"
                                    style={{ width: "18px", marginLeft: "2px" }}
                                />
                            </div>
                        ) : (
                            <div
                                className={`${styles.calendar_day} ${styles.other_day_extra}`}
                            >
                                <div className={styles.day_number}>{day}</div>
                            </div>
                        )
                    ) : (
                        <div
                            className={`${styles.calendar_day} ${styles.other_day}`}
                        >
                            <div className={styles.day_number}>{day}</div>
                            {renderOnlySeventhDayTokenAmount}
                        </div>
                    )}
                </div>
            ) : (
                <div
                    className={`${styles.day_container} ${
                        day === endOfMonthDate &&
                        day % 7 !== 0 &&
                        styles.grid_double_span
                    }`}
                    style={{
                        width:
                            day === endOfMonthDate && day % 7 !== 0
                                ? "150px"
                                : "",
                    }}
                >
                    {day > 28 ? (
                        day === endOfMonthDate ? (
                            <div
                                className={`${styles.calendar_day} ${styles.other_day_extra_final}`}
                            >
                                <div className={styles.day_number}>{day}</div>
                                <span className={styles.text}>Attendance</span>
                                <img
                                    src={TreasureChestBadgeBrown}
                                    className={styles.badge_img}
                                    alt="treasure-chest-badge"
                                />
                                <span className={styles.text}>+</span>
                                <img
                                    src={BoxPrizeBrown}
                                    className={styles.map_img}
                                    alt="box-prize"
                                    style={{ width: "18px", marginLeft: "2px" }}
                                />
                            </div>
                        ) : day <= endOfMonthDate ? (
                            <div
                                className={`${styles.calendar_day} ${styles.other_day_extra}`}
                            >
                                <div className={styles.day_number}>{day}</div>
                            </div>
                        ) : (
                            ""
                        )
                    ) : (
                        <div
                            className={`${styles.calendar_day} ${styles.other_day}`}
                        >
                            <div className={styles.day_number}>{day}</div>
                            {renderOnlySeventhDayTokenAmount}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export { CalendarDay };
